export const DESK_LANDING_PATH = '/home/desk';
